export enum Environments {
  Local = "local",
  Dev = "Development",
  Sit = "SIT",
  AuroraSit = "AuroraSit",
  Uat = "UAT",
  Prod = "Production"
}
